// extracted by mini-css-extract-plugin
module.exports = {"share-icons":"share_campaign__share-icons___38Eqs","share-icon":"share_campaign__share-icon___35bEv","sub-text":"share_campaign__sub-text___25sT4 _type__vx_text-6_lighter___2qDBi"};